import { render, staticRenderFns } from "./receipt-red-add-or-update.vue?vue&type=template&id=f0a2cc6e&scoped=true"
import script from "./receipt-red-add-or-update.vue?vue&type=script&lang=js"
export * from "./receipt-red-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./receipt-red-add-or-update.vue?vue&type=style&index=0&id=f0a2cc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2cc6e",
  null
  
)

export default component.exports